module.exports = __webpack_public_path__ + "media/Images/edit-1338f3ac7c55823ca34638d8f251c91d.svg";